import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/config/";
const url = apiUrl + endPoint;

export async function getConfig() {
  return await http.get(url);
}

export async function updateConfig(config) {
  const configId = config._id;
  const payload = { ...config };
  delete payload._id;
  return await http.put(url + configId, payload);
}
